/**
 * App.js - Root: ThemeProvider (theme color + Poppins like admin4.0) + PermissionsProvider + Muidrawer.
 * Cache: sessionStorage only via CacheProviderService.
 */
import "./App.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Muidrawer from "./Shell/Muidrawer";
import { PermissionsProvider } from "./Utility/PermissionContext";
import { Colors } from "./Styles/Colors";

const theme = createTheme({
  typography: {
    fontFamily: '"Poppins", sans-serif',
    fontSize: 15,
    htmlFontSize: 16,
    body1: { fontSize: "0.95dvw" },
    body2: { fontSize: "0.9dvw" },
    caption: { fontSize: "0.8dvw" },
    subtitle1: { fontSize: "1dvw" },
    subtitle2: { fontSize: "0.95dvw" },
    button: { fontSize: "0.9dvw", textTransform: "capitalize" },
    h6: { fontSize: "1.1dvw" },
  },
  palette: {
    background: {
      default: Colors.BgColor,
    },
    primary: {
      main: Colors.ThemeColor,
      contrastText: Colors.ContrastText,
    },
    secondary: {
      main: Colors.SecondaryColor,
      contrastText: Colors.ContrastText,
    },
    others: {
      main: "#c400ff",
      light: "#d966ff",
      dark: "#ad00e0",
      contrastText: Colors.ContrastText,
    },
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: "0.95dvw",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: "0.9dvw",
        },
        head: {
          fontSize: "0.95dvw",
          fontWeight: 600,
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: "0.95dvw",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: "0.95dvw",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "0.95dvw",
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: "0.8dvw",
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          fontSize: "0.9dvw",
        },
        columnHeader: {
          fontSize: "0.95dvw",
          fontWeight: 600,
        },
        cell: {
          fontSize: "0.9dvw",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: Colors.pageTopBackground,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        label: {
          fontSize: "0.85dvw",
        },
        root: {
          "&.MuiChip-colorOthers": {
            "&:hover": {
              backgroundColor: "#d678f3ff",
            },
          },
        },
      },
    },
  },
});

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <PermissionsProvider>
        <Muidrawer />
      </PermissionsProvider>
    </ThemeProvider>
  );
}
